import { useState } from "react";
import { Row, Col, Form, Container, FormGroup, Breadcrumb, Navbar } from "react-bootstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getMonthWiseDiscountReport } from "./Report.action";
import _ from "lodash";
import Swal from 'sweetalert';
import moment from "moment";
import IconMenu from "../../../drawer/IconMenu";
import SendIcon from '@mui/icons-material/Send';
import Button from '@mui/material/Button';


const MonthWiseDiscountReport = (props) => {
    const [startDate, setStartDate] = useState(moment().subtract(1, 'months').format("YYYY-MM-DD"));
    const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [dangerVisibleAlert, setDangerVisibleAlert] = useState(false);

    const handleDangerVisible = () => {
        setDangerVisibleAlert(true)
        setTimeout(() => {
            setDangerVisibleAlert(false)
        }, 9000);
        Swal({
            title: "Error",
            text: "Something went Wrong!",
            icon: "error",
            button: "Ok",
        });
    }
    const exportPDF = () => {
        props.getMonthWiseDiscountReport({ startDate: startDate, endDate: endDate },
            handleDangerVisible)
    }

    return (
        <>
            <Navbar style={{ backgroundColor: '#81abd3' }}  >
                <Container>
                    <Navbar.Brand style={{ color: 'white' }}><b>Monthly Discount Report</b></Navbar.Brand>
                    <IconMenu />
                </Container>
            </Navbar>

            <Container fluid>
                <div className="main">
                    <Row>
                        <Breadcrumb>
                            <Breadcrumb.Item ><Link to="/home">Home</Link></Breadcrumb.Item>
                            <Breadcrumb.Item ><Link to="/report">Report</Link> </Breadcrumb.Item>
                            <Breadcrumb.Item active>Monthly Discount Report</Breadcrumb.Item>
                        </Breadcrumb>
                    </Row>
                    <Row>
                        <Col>
                            <FormGroup>
                                <Form.Label><b>Start Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                >
                                </Form.Control>
                            </FormGroup>
                        </Col>
                        <Col>
                            <FormGroup>
                                <Form.Label><b>End Date *</b></Form.Label>
                                <Form.Control
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                >
                                </Form.Control>
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className="sendDiv">
                        {_.isEmpty(startDate) || _.isEmpty(endDate) ? (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" disabled> Generate Report </Button>
                        ) : (
                            <Button variant="contained" endIcon={<SendIcon />} size="large" onClick={() => exportPDF()}> Generate Report </Button>
                        )}
                    </div>

                </div>
            </Container>
        </>
    );
};
const mapDispatchToProps = (dispatch) => {
    return {
        getMonthWiseDiscountReport: (data, handleDangerVisible) => dispatch(getMonthWiseDiscountReport(data, handleDangerVisible)),
    };
};
const mapStateToProps = (state, ownProps) => ({
    isFetchingMonthlyDiscountReport: state.ReportReducer.isFetchingMonthlyDiscountReport,
    monthlyDiscountReportData: state.ReportReducer.monthlyDiscountReportData,
});

export default connect(mapStateToProps, mapDispatchToProps)(MonthWiseDiscountReport);